import { AxiosRequestConfig } from "axios"
import { ApiUrl } from "src/constant/endpoints"
import api from "src/services/axiosInstance"

export const getDataListVoucher = async (params: {
  page?: number
  size?: number
  filterType?: number
  voucherType?: string
  brandId?: string
}): Promise<AxiosRequestConfig> => {
  return api.request({
    url: ApiUrl.LIST_MY_VOUCHER,
    method: "GET",
    params: params,
    tokenRequired: true,
  })
}
